import type { FC } from 'react';
import {
  useState, useEffect,
} from 'react';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';

import GenericRewardsSection from 'components/RewardSection';
import type { TextUnderCardProps } from 'components/TextUnderCard';
import { selectCollectionCounters } from 'store/collection/collectionSelectors';
import type { Card, Collection } from '@starly/starly-types';

interface RewardsSectionProps {
  collectionId: string,
  collection: Collection & { _cached_cards_reward: Card[] }
}

const RewardsSection: FC<RewardsSectionProps> = ({ collectionId, collection }) => {
  const collectionCounters = useSelector(selectCollectionCounters(collectionId));

  const [textForRewardCards, setTextForRewardCards] = useState<TextUnderCardProps[]>();

  useEffect(() => {
    if (collection && collectionCounters) {
      setTextForRewardCards(
        (collection._cached_cards_reward || []).map((card) => {
          const cardCounter = collectionCounters[card.id];
          return {
            listing: !!cardCounter?.for_sale,
            price: cardCounter?.lowest_price || 0,
            listingsCount: cardCounter?.listings || 0,
          };
        }),
      );
    }
  }, [collection, collectionCounters]);

  if (!(collection._cached_cards_reward?.length)) {
    return null;
  }

  return (
    <GenericRewardsSection
      cards={collection._cached_cards_reward || []}
      rewardDate={dayjs(+collection.reward_date?.seconds * 1000)}
      collectionId={collectionId}
      collection={collection}
      textForCards={textForRewardCards || []}
    />
  );
};

export default RewardsSection;
